import classNames from "@calcom/ui/classNames";
import Image from "next/image";
import type { ComponentProps } from "react";

type BookifullLogoProps = Omit<ComponentProps<typeof Image>, "alt" | "height" | "src" | "width"> & {
  variant?: "primary" | "white";
};

const logoSources = {
  primary: "/bookifull/brand/bookifull-logo.svg",
  white: "/bookifull/brand/bookifull-logo-white.svg",
} as const;

export function BookifullLogo({ className, variant = "primary", ...props }: BookifullLogoProps): JSX.Element {
  return (
    <Image
      {...props}
      alt="Bookifull"
      className={classNames("h-auto w-full", className)}
      height={138}
      src={logoSources[variant]}
      unoptimized
      width={551}
    />
  );
}
